<template>
  <div>
    <p>
      {{
        Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(price)
      }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'freightPrice',

  props: {
    price: 0.0,
  },

  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Freight/FreightPrice.vue